import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-page',
	templateUrl:'./PagePluginCompPage.html',
	styles: [],
	styleUrls:['./PagePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class PagePluginCompPage
{
	mdContent_1083 = `\`\`\`java
import com.jwebmp.core.base.html.Page;
\`\`\``;
	mdContent_1084 = `\`\`\`java
Page()
\`\`\``;
	mdContent_1085 = `\`\`\`java
Page&lt;?&gt; page = new Page&lt;&gt;();
page.setTitle("My App");
page.getBody().add(new H1&lt;&gt;().setText("Hello"));
page.getBody().add(new Paragraph&lt;&gt;().setText("Welcome"));
String html = page.toString(true);
\`\`\``;
}
